import { SET_CURRENT_RESERVATION, SET_LOADING_STATE, SET_ERROR_CODE } from '../ActionTypes/reservations';
// @ts-ignore TODO: revisit redux typings
import { AppDispatch } from '../../App';
import { ReservationDetails } from '@/types/reservation';

import { ReservationsService } from '@/services/api/reservations-service';
import { ErrorTypes } from '@/services/api/errorCodes';

export const setCurrentReservation = (reservation: ReservationDetails) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_CURRENT_RESERVATION,
        reservation,
    });
};

export const isFetching = (loading: boolean) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_LOADING_STATE,
        loading,
    });
};

export const fetchError = (error: ErrorTypes) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_ERROR_CODE,
        error,
    });
    dispatch(isFetching(false));
};

// ======= ASYNC

export const fetchReservationDetails = (reservationId: string) => async (dispatch: AppDispatch) => {
    const reservationService = new ReservationsService();
    dispatch(isFetching(true));
    const reservation = await reservationService.get(reservationId);

    // @ts-ignore revisit typings
    if (reservation.errorCode) {
        // @ts-ignore revisit typings
        dispatch(fetchError(reservation.errorCode));
        return;
    }
    // @ts-ignore revisit typings
    dispatch(setCurrentReservation(reservation));
    dispatch(isFetching(false));
};
